import React from 'react';
import Input from '../../../../components/ui/Input.jsx';

const TcpDumpSection = ({
  formData,
  inputs,
  handleInputChange,
  copyToClipboard,
  lanIpEnabled,
  toggleLanIp,
}) => {
  const phoneNum = 1;

  return (
    <div className='flex flex-col p-6 bg-slate-100 rounded-2xl border-red-600 border-solid border-2'>
      <h1 className='font-bold text-3xl mb-4'>TCPDUMP</h1>

      <div className='p-4 bg-white rounded-lg shadow'>
        <div className='mb-4'>
          <h2 className='font-semibold text-lg mb-2'>
            Phone's IP Address for the TCPDUMP command:
          </h2>
          <div className='relative mb-2'>
            {lanIpEnabled[`phone${phoneNum}`] ? (
              <div className='flex items-center'>
                <span className='text-gray-700 mr-1'>192.168.1.</span>
                <Input
                  id={`phone${phoneNum}IpAddress`}
                  value={
                    formData[`phone${phoneNum}IpAddress`]?.replace(
                      '192.168.1.',
                      ''
                    ) || 'xxx'
                  }
                  onChange={e => {
                    const newValue = `192.168.1.${e.target.value}`;
                    handleInputChange({
                      target: {
                        id: `phone${phoneNum}IpAddress`,
                        value: newValue,
                      },
                    });
                  }}
                  className='w-20 p-2 border rounded'
                />
              </div>
            ) : (
              <Input
                id={`phone${phoneNum}IpAddress`}
                value={formData[`phone${phoneNum}IpAddress`]}
                onChange={handleInputChange}
                placeholder='Manually enter IP or use toggle below'
                className='w-full p-2 border rounded'
              />
            )}
          </div>

          <div className='flex items-center gap-2'>
            <button
              onClick={() => toggleLanIp(phoneNum)}
              className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                lanIpEnabled[`phone${phoneNum}`]
                  ? 'bg-blue-600'
                  : 'bg-gray-200'
              }`}
            >
              <span
                className={`inline-block w-4 h-4 transform transition-transform ${
                  lanIpEnabled[`phone${phoneNum}`]
                    ? 'translate-x-6'
                    : 'translate-x-1'
                } bg-white rounded-full`}
              />
              <span className='sr-only'>Use LAN IP</span>
            </button>
            <span className='text-sm text-gray-500'>
              {lanIpEnabled[`phone${phoneNum}`] ? (
                'Un-toggle to manually enter IP address'
              ) : (
                <>
                  Toggle to fill with <span className='font-bold'>192.168.1.xxx</span>
                </>
              )}
            </span>
          </div>
        </div>

        <div>
          <h3 className='font-medium text-md'>TCPDUMP Command:</h3>
          <div className='p-3 bg-gray-100 rounded font-mono text-sm break-all my-2'>
            {inputs[`inputTcpDumpPhone${phoneNum}`].value}
          </div>
          <button
            onClick={() => copyToClipboard(
              'tcpdumpCommand', 
              inputs[`inputTcpDumpPhone${phoneNum}`].value
            )}
            className='px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-2'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={1.5}
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184'
              />
            </svg>
            Copy Command
          </button>
          <p
            id='tcpdumpCommand-message'
            className='hidden text-green-600 mt-1 text-sm'
          ></p>
        </div>
      </div>
    </div>
  );
};

export default TcpDumpSection;